import { 
    HeartPulse, Globe, Building, Joystick, BrainCircuit, ServerCog, Component, BookMarked,
    CirclePower, HeartHandshake, TvMinimalPlay, Laptop, PencilLine, MonitorDot, Layers,
    FingerprintPattern, Building2, Cog, Trees, FileBox, Brain, Scale, Monitor, University, Factory 
} from "lucide-react";

export const projects = [
    {   
        id: 1,
        project: {
            brand: "EMRYS",
            title: "Medical Crypto Platform",
            icon: <HeartPulse className="sizedIcon"/>,
            tags: [
                { tag: "Platform", icon: <Globe/> },
                { tag: "Crypto", icon: null }
            ],
            stage: "development",
            category: {
                name: "Medicine",
                icon: <HeartPulse/>
            },
            in_progress: true,
            release_date: "01/01/2028",
            description: "Emrys is a revolutionary international healthcare platform leveraging blockchain technology and cryptocurrency to provide free, high-quality medical services globally. By connecting patients, doctors, and medical institutions, Emrys ensures secure and transparent exchange of medical information. Utilizing smart contracts, the platform protects data privacy and streamlines service access without financial barriers. Emrys empowers users to receive world-class healthcare by minimizing bureaucratic hurdles and eliminating costs, fostering a more accessible and efficient healthcare ecosystem for everyone involved.",
        },
        socials: {
            x: {
                enable: true,
                link: 'https://x.com/EmrysMedical'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/emrys_medical_news' },
                    { name: 'Bot', link: 'https://t.me/emrys_medical_bot' },
                    { name: 'Group', link: 'https://t.me/emrys_medical_discussion' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: null
            },
            donate: {
                enable: true,
                link: null
            },
            website: {
                enable: true,
                link: null
            }
        }
    },
    {   
        id: 2,
        project: {
            brand: "Epidaurus",
            title: "Psychological Support Platform",
            icon: <Brain className="sizedIcon"/>,
            tags: [
                { tag: "Platform", icon: <Globe/> },
                { tag: "Mental Health", icon: null }
            ],
            stage: "development",
            category: {
                name: "Medicine",
                icon: <HeartPulse />
            },
            in_progress: true,
            release_date: "01/01/2028",
            description: "This platform offers free psychological support to individuals in need of guidance and assistance in the field of mental health. It provides a safe and anonymous environment for users, creating comfortable conditions for communication. The platform connects people with qualified professionals who offer consultations, resources, and tools to improve emotional well-being. Aiming to eliminate barriers to access, it makes mental health support available to everyone, regardless of financial circumstances. The primary focus is on creating a safe space for sharing experiences, receiving support, and finding pathways to healing and personal development.",
        },
        socials: {
            x: {
                enable: true,
                link: 'https://x.com/PsyTherapyMedical'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/epidaurus_news' },
                    { name: 'Bot', link: 'https://t.me/epidaurus_bot' },
                    { name: 'Group', link: 'https://t.me/epidaurus_discussion' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: 'https://epidaurus.world'
            }
        }
    },
    {   
        id: 3,
        project: {
            brand: "Vulcan",
            title: "Automated OS Assembly Platform",
            icon: <ServerCog className="sizedIcon"/>,
            tags: [
                { tag: "Platform", icon: <Globe/> },
                { tag: "OS", icon: null }
            ],
            stage: "development",
            category: {
                name: "Automation",
                icon: <Cog />
            },
            in_progress: true,
            release_date: "01/12/2027",
            description: 'This modern platform is designed for the automated assembly of operating systems, aimed at simplifying and enhancing the customization process for developers and organizations. Users can effortlessly create tailored operating systems by integrating essential programs, applying unique interface styles, modifying the kernel, and implementing advanced encryption features. This powerful tool streamlines the entire assembly process, allowing developers to focus on innovation rather than manual configurations. By harnessing its capabilities, users can ensure that their operating systems are not only functional but also secure and visually appealing.',
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/vulcan_news' },
                    { name: 'Bot', link: 'https://t.me/vulcan_bot' },
                    { name: 'Group', link: 'https://t.me/vulcan_discussion' },
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 4,
        project: {
            brand: "Artemida",
            title: "Security Breach Tester",
            icon: <FingerprintPattern className="sizedIcon"/>,
            tags: [
                { tag: "Platform", icon: <Globe/> },
                { tag: "Security", icon: null }
            ],
            stage: "development",
            category: {
                name: "Automation",
                icon: <Cog />
            },
            in_progress: true,
            release_date: "01/12/2025",
            description: "This platform provides users with the ability to test the security of their systems and applications. It offers a wide range of tools and resources for identifying vulnerabilities and assessing the level of protection. Users can conduct both automated and manual tests, analyze results, and receive recommendations for improving security. The platform is designed for developers, IT professionals, and companies looking to safeguard their data and infrastructure from potential threats. The primary focus is on ease of use, accessibility, and effectiveness, enabling users to quickly and efficiently identify and mitigate risks, ensuring robust protection of their digital assets.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/artemida_news' },
                    { name: 'Bot', link: 'https://t.me/artemida_bot' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 5,
        project: {
            brand: "Terrabyte",
            title: "Technology Trading Platform",
            icon: <Scale className="sizedIcon"/>,
            tags: [
                { tag: "Platform", icon: <Globe/> },
                { tag: "Trading", icon: null }
            ],
            stage: "development",
            category: {
                name: "Automation",
                icon: <Cog />
            },
            in_progress: true,
            release_date: "01/06/2026",
            description: "Terrabyte platform enables individuals, companies, and nations to buy and sell transformative technologies seamlessly. From renewable energy solutions to advanced medical innovations, the platform hosts a comprehensive global database of technologies, fostering collaboration and innovation. By facilitating secure transactions and knowledge exchange, it empowers countries to overcome challenges, bridge technological gaps, and drive progress toward a sustainable future.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/terrabyte_news' },
                    { name: 'Bot', link: 'https://t.me/terrabyte_bot' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 6,
        project: {
            brand: "RedBoot",
            title: "Unified OS Bootloader",
            icon: <CirclePower className="sizedIcon"/>,
            tags: [
                { tag: "Bootloader", icon: <CirclePower/> },
                { tag: "Security", icon: null }
            ],
            stage: "development",
            category: {
                name: "Security",
                icon: <FingerprintPattern />
            },
            in_progress: true,
            release_date: "01/02/2027",
            description: "RedBoot is a universal OS bootloader optimized for extreme security and granular customization in multi-boot environments. It integrates robust protections like secure boot verification and intrusion detection. Customize security from ironclad encryption and biometric access to paranoid self-destruct modes that wipe all disk data on threats.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/code_red_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: null
            },
            donate: {
                enable: true,
                link: null
            },
            website: {
                enable: true,
                link: null
            }
        }
    },
    {   
        id: 7,
        project: {
            brand: "Samaritan",
            title: "AI OS",
            icon: <MonitorDot className="sizedIcon"/>,
            tags: [
                { tag: "AI", icon: <BrainCircuit/> },
                { tag: "OS", icon: null }
            ],
            stage: "development",
            category: {
                name: "OS",
                icon: <MonitorDot />
            },
            in_progress: true,
            release_date: "01/01/2031",
            description: "An AI-Powered Operating System for Corporate Needs. Advanced artificial intelligence to streamline operations, enhance productivity, and optimize workflows across your organization. Intelligent automation to reduce routine tasks, data-driven insights for informed decision-making, enhanced collaboration tools for seamless teamwork, robust security measures to protect sensitive information, scalability to adapt to your growing business, and a user-friendly interface that promotes easy adoption across teams.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/samaritan_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 8,
        project: {
            brand: "Samaritan Web",
            title: "AI Web",
            icon: <Globe className="sizedIcon"/>,
            tags: [
                { tag: "AI", icon: <BrainCircuit/> },
                { tag: "Browser", icon: null }
            ],
            stage: "development",
            category: {
                name: "Network",
                icon: <Globe />
            },
            in_progress: true,
            release_date: "01/01/2029",
            description: "An AI-Powered Web Browser for Corporate Needs. Advanced artificial intelligence designed to streamline operations, boost productivity, and optimize workflows within your organization. Intelligent automation to minimize routine tasks, data-driven insights for informed decision-making, enhanced collaboration tools for seamless teamwork, robust security measures to safeguard sensitive information, scalability to accommodate your growing business, and a user-friendly interface that facilitates easy adoption across teams.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/samaritan_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 9,
        project: {
            brand: "Octara",
            title: "Internet Layer Overlay Protocol",
            icon: <Layers className="sizedIcon"/>,
            tags: [
                { tag: "Network", icon: <Globe/> },
                { tag: "Decentralized", icon: null }
            ],
            stage: "development",
            category: {
                name: "Network",
                icon: <Globe />
            },
            in_progress: true,
            release_date: "01/12/2026",
            description: "A decentralized overlay network protocol providing global connectivity. Octara is an experimental, self-organizing mesh network that runs completely independent of the existing internet infrastructure. It creates a flat, end-to-end encrypted network where every node acts as a router. There are no root servers, no central directory, and no single point of failure.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: false,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: false,
                links: []
            }
        },
        buttons: {
            kickstarter: {
                enable: false,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: false,
                link: '/'
            }
        }
    },
    {   
        id: 10,
        project: {
            brand: "Erebion",
            title: "Plastic recycling center",
            icon: <Trees className="sizedIcon"/>,
            tags: [
                { tag: "Factory", icon: <Factory/> },
                { tag: "Ecology", icon: null }
            ],
            stage: "development",
            category: {
                name: "Ecology",
                icon: <Trees />
            },
            in_progress: true,
            release_date: "01/01/2030",
            description: "Project aims to revolutionize plastic waste management by creating a cutting-edge facility that transforms discarded plastics into high-quality spunbond for sustainable applications. Equipped with advanced CO2 capture systems, the plant will significantly reduce carbon emissions. Designed with a commitment to ecological preservation, it will process millions of tons of plastic annually, paving the way for a cleaner planet and a thriving circular economy.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/erebion_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: 'https://erebion.tech'
            }
        }
    },
    {   
        id: 11,
        project: {
            brand: "Haven",
            title: "Shelter for homeless people and animals",
            icon: <Building2 className="sizedIcon"/>,
            tags: [
                { tag: "Homeless Assistance Center", icon: <Building /> },
                { tag: "Social", icon: null }
            ],
            stage: "development",
            category: {
                name: "Social",
                icon: <HeartHandshake />
            },
            in_progress: true,
            release_date: "01/01/2030",
            description: "Shelter offers a transformative haven for homeless individuals and animals, fostering a unique community built on mutual care. Residents receive nourishing meals, access to resocialization programs, and support for reintegration into society. Through tailored training, we will give people with new skills and job placement opportunities, helping them rebuild their lives. A cryptocurrency-based reward system incentivizes participation and progress. In return, residents care for animals, creating bonds that heal and inspire.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/shelter_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 12,
        project: {
            brand: "Minerva",
            title: "Cultural learning centers",
            icon: <University className="sizedIcon"/>,
            tags: [
                { tag: "Cultural center", icon: <University /> },
                { tag: "Social", icon: null }
            ],
            stage: "development",
            category: {
                name: "Social",
                icon: <University />
            },
            in_progress: true,
            release_date: "01/01/2031",
            description: "This cultural center offers a welcoming space where everyone can explore their passions for free. From sports and vocal training to dance, art, and theater, individuals of all ages engage in diverse cultural activities. Designed to inspire creativity and community, the center provides a safe haven for teenagers, steering them away from alcohol, smoking, and drugs through meaningful experiences that foster personal growth and connection.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/minerva_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 13,
        project: {
            brand: "Diary of a Madman",
            title: "Interactive Infinite Book",
            icon: <BookMarked className="sizedIcon"/>,
            tags: [
                { tag: "Platform", icon: <Globe/> },
                { tag: "Book", icon: null }
            ],
            stage: "development",
            category: {
                name: "Book",
                icon: <BookMarked/>
            },
            in_progress: true,
            release_date: "01/06/2026",
            description: 'Enter a world where reality twists and sanity fades in "Diary of a Madman". This gripping horror novel takes you on an unending journey through the mind of a tormented soul. As you turn each page, you will be drawn deeper into a chilling narrative filled with dark secrets, haunting visions, and the ever-present threat of madness. Every entry in this diary reveals a new layer of horror, blurring the lines between the writer’s nightmarish imagination and the terrifying truth. Will you dare to uncover the secrets that lie within? Prepare for a reading experience that never truly ends, as the horrors of the mind linger long after the last page is turned. Dare to delve into the madness?',
        },
        socials: {
            x: {
                enable: false,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/diary_of_madman_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 14,
        project: {
            brand: "Labyrinth of the Mind",
            title: "Diary of a Madman (Game)",
            icon: <Joystick className="sizedIcon"/>,
            tags: [
                { tag: "Game", icon: <Joystick/> },
                { tag: "Horror", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/08/2026",
            description: "Step into the fragmented psyche of a haunted protagonist as you navigate the twisting, ever-changing corridors of their own mind—a labyrinth filled with haunting memories, dark secrets, and manifestations of their deepest fears. In this horror game, the environment will dynamically shift around you, reflecting the chaos and turmoil within. Each turn may reveal unsettling visions and grotesque entities that embody the protagonist's inner demons. Solve intricate puzzles that challenge your perception of reality, and confront the shadows lurking in the deepest recesses of your mind.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/diary_of_madman_game_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 15,
        project: {
            brand: "The Forgotten Dreams",
            title: "Adventures of little girl",
            icon: <Joystick className="sizedIcon"/>,
            tags: [
                { tag: "Game", icon: <Joystick/> },
                { tag: "Horror", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2027",
            description: "This is an indie horror game that invites players to embark on a mesmerizing journey through a dreamlike realm where nightmares and fantasies intertwine. Players control a brave little girl as she traverses a series of vividly contrasting worlds, each filled with its own unique challenges and breathtaking visuals. The game seamlessly blends elements of horror and fantasy, creating an immersive experience that keeps players on their toes. With each world offering its own distinct atmosphere and narrative, players will unravel the mysteries of the girl's dreams, discovering the deeper meanings behind her journey.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/aolg_game_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 16,
        project: {
            brand: "Whispers in the Twilight",
            title: "Adventures of little prince",
            icon: <Joystick className="sizedIcon"/>,
            tags: [
                { tag: "Game", icon: <Laptop/> },
                { tag: "Horror", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2027",
            description: "This is an indie horror game inspired by the finest works of Edgar Allan Poe, where darkness and mystery intertwine in an engaging and terrifying adventure. Immerse yourself in a world where the brave little prince embarks on a journey through grim and unsettling landscapes filled with ghosts, secrets, and inner demons. Each location—from abandoned castles to shadowy forests—is rich with atmospheric details and surreal elements that reflect the gothic and mystical essence of Poe's writings. Discover dark mysteries and find light even in the darkest corners as the little prince sets out on a quest for his true self in this captivating and haunting adventure inspired by the greatest works of Edgar Allan Poe.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/aolp_game_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 17,
        project: {
            brand: "Phantoms of the Starry Night",
            title: "Adventures of little prince 2",
            icon: <Joystick className="sizedIcon"/>,
            tags: [
                { tag: "Game", icon: <Laptop/> },
                { tag: "Horror", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2028",
            description: "The second part of the game. This new installment features an entirely new story, introducing fresh enemies and captivating environments. Players will explore diverse worlds filled with stunning celestial landscapes, each brimming with unique challenges and mysteries. ",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/aolp2_game_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 18,
        project: {
            brand: "Enemy Infestation",
            title: "Full Remaster Mod",
            icon: <Joystick className="sizedIcon"/>,
            tags: [
                { tag: "Mod", icon: <Laptop/> },
                { tag: "Remaster", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2026",
            description: "'Enemy Infestation' plunges players into a gripping, fast-paced strategy experience where survival is the ultimate goal. Set in a dystopian future, you must fend off relentless waves of alien invaders intent on taking over your territory. Utilize a variety of weapons, traps, and tactical strategies to outsmart and outmaneuver the enemy forces. As you progress, unlock new technologies and upgrade your defenses to withstand increasingly challenging onslaughts. With its intense gameplay, immersive environments, and heart-pounding action, 'Enemy Infestation' offers a thrilling test of skill and strategy that will keep you on the edge of your seat.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/ei_remaster_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 19,
        project: {
            brand: "Dark Colony",
            title: "Full Remaster Mod",
            icon: <Joystick className="sizedIcon"/>,
            tags: [
                { tag: "Mod", icon: <Laptop/> },
                { tag: "Remaster", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2026",
            description: "Dark Colony invites players to explore a hauntingly atmospheric sci-fi world where humanity's survival hangs in the balance. Set on a distant planet, you must build and manage a colony while navigating the dangers of alien life forms and environmental challenges.",
        },
        socials: {
            x: {
                enable: true,
                link: '/'
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/dc_remaster_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 20,
        project: {
            brand: "Echoes of Pain",
            title: "StarCraft: Echoes of Pain",
            icon: <BookMarked className="sizedIcon"/>,
            tags: [
                { tag: "Book", icon: <BookMarked/> },
                { tag: "Horror", icon: null }
            ],
            stage: "development",
            category: {
                name: "Book",
                icon: <BookMarked/>
            },
            in_progress: true,
            release_date: "01/12/2026",
            description: 'An alternative history of the Koprulu sector. The story of the beginning and end of civilizations in the StarCraft world.',
        },
        socials: {
            x: {
                enable: false,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/echoes_of_pain_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 21,
        project: {
            brand: "Echoes of Pain: Game",
            title: "Campaings for StarCraft 2",
            icon: <FileBox className="sizedIcon"/>,
            tags: [
                { tag: "Mod", icon: <Laptop/> },
                { tag: "Campaigns", icon: null }
            ],
            stage: "development",
            category: {
                name: "Modification",
                icon: <Component/>
            },
            in_progress: true,
            release_date: "01/12/2026",
            description: 'An alternative history of the Koprulu sector. The story of the beginning and end of civilizations in the StarCraft world. Play as old factions in new scenarios. Over 90 new missions in 6 new campaigns.',
        },
        socials: {
            x: {
                enable: false,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/echoes_of_pain_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 22,
        project: {
            brand: "Devastated Worlds",
            title: "Modification for The Witcher 3",
            icon: <FileBox className="sizedIcon"/>,
            tags: [
                { tag: "Mod", icon: <Laptop/> },
                { tag: "Maps", icon: null }
            ],
            stage: "development",
            category: {
                name: "Modification",
                icon: <Component/>
            },
            in_progress: true,
            release_date: "01/12/2028",
            description: 'An expanded history of Geralt`s travels to other worlds. Includes such worlds as Tedd Deireadh, Ddiddiwedht, Mysterious World, World of King Arthur.',
        },
        socials: {
            x: {
                enable: false,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/devastated_worlds_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 23,
        project: {
            brand: "Rise of the Etherborn",
            title: "Nox: Rise of the Etherborn",
            icon: <FileBox className="sizedIcon"/>,
            tags: [
                { tag: "Mod", icon: <Laptop/> },
                { tag: "New Story", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2032",
            description: 'Years after the last battle, a mysterious rift has torn open the skies, unleashing the Etherborn—a forgotten race of sorcerers wielding unstable, reality-bending magic. As Jack Mower, now a seasoned hero, you’ll uncover a sinister plot threatening to unravel the fabric of your world. Ally with new companions, master ancient spells, and face epic foes in a breathtaking open-world adventure. The fate of Nox hangs in the balance—will you rise to the challenge?',
        },
        socials: {
            x: {
                enable: false,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/nox_2_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {   
        id: 24,
        project: {
            brand: "Salted Abyss",
            title: "Modification for Fallout Tactics",
            icon: <FileBox className="sizedIcon"/>,
            tags: [
                { tag: "Mod", icon: <Laptop/> },
                { tag: "New Story", icon: null }
            ],
            stage: "development",
            category: {
                name: "Game",
                icon: <Joystick />
            },
            in_progress: true,
            release_date: "01/01/2035",
            description: 'Fallout: Salted Abyss takes you to the harsh and uncharted Great Basin Desert, where radiation and despair have created a new world of survival. In the year 2290, decades after the fall of the Enclave, you, one of the last descendants of survivors, embark on an odyssey across vast salt plains, dry lake beds, and mountain strongholds. Your mission is to find a lost bunker where water desalination experiments were conducted before the Great War, the only hope for saving dying communities.',
        },
        socials: {
            x: {
                enable: false,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: true,
                link: null
            },
            telegram: {
                enable: true,
                links: [
                    { name: 'News', link: 'https://t.me/ft_sa_news' }
                ]
            }
        },
        buttons: {
            kickstarter: {
                enable: true,
                link: '/'
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
    {
        id: 25,
        project: {
            brand: "Aeneas",
            title: "Journeys of Reintegration",
            icon: <PencilLine className="sizedIcon"/>,
            tags: [
                { tag: "Show", icon: <TvMinimalPlay /> },
                { tag: "Help", icon: null }
            ],
            stage: "development",
            category: {
                name: "Social",
                icon: <HeartHandshake />
            },
            in_progress: true,
            release_date: "01/05/2026",
            description: 'This initiative follows the real-life journeys of people experiencing homelessness as they rebuild their lives step by step. Through daily reflections, participants share their experiences of finding stable housing, accessing essential medical and psychological support, overcoming challenges, and successfully reintegrating into society — including securing employment and restoring meaningful connections. The project not only provides practical assistance with shelter, food, treatment, and social needs but also highlights the strength and resilience of each individual. By openly sharing these stories of transformation, we aim to reduce stigma around homelessness, inspire hope, and promote our free medicine and psychology platform as a vital resource for anyone in need.',
        },
        socials: {
            x: {
                enable: true,
                link: null
            },
            youtube: {
                enable: true,
                link: null
            },
            reddit: {
                enable: false,
                link: null
            },
            telegram: {
                enable: false,
                links: []
            }
        },
        buttons: {
            kickstarter: {
                enable: false,
                link: null
            },
            donate: {
                enable: true,
                link: '/'
            },
            website: {
                enable: true,
                link: '/'
            }
        }
    },
]